// Centralised dashboard IDs file

// Standby Dashboard IDs (Placeholders)
export const enterprise_supplier_development_dashboard_id = 'standby-id';
export const esd_compliance_dashboard_id = '64b355e7-2f1c-4612-88ac-e54854d93337';
export const esd_programmes_delivery_dashboard_id = '5123aab7-1f1c-4a10-be34-496569e22740';
export const esd_social_impact_dashboard_id = '1173c8c7-15c2-4f5d-bcd0-d971b5ae6ae5';

// Default main dashboard
export const main_dashboard_id = esd_programmes_delivery_dashboard_id;

// Role-based global dashboard mappings (per sidebar nav key)
const standardized_mapping = {
  default: esd_programmes_delivery_dashboard_id,
  
  // ESD
  'enterprise_supplier_development': enterprise_supplier_development_dashboard_id,
  'esd_compliance': esd_compliance_dashboard_id,
  'esd_programmes_delivery': esd_programmes_delivery_dashboard_id,
  'esd_social_impact': esd_social_impact_dashboard_id
};

export const role_dashboards = {
  admin: standardized_mapping,
  fund_manager: standardized_mapping,
  donor: standardized_mapping,
  governance: standardized_mapping,
  entrepreneur: standardized_mapping
};
